import { useTacticHooks } from '../providers/TacticHooksProvider';
import { useQuery } from '@tanstack/react-query';

export const useOrganizationQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ['users.organizations'],

    queryFn: async () => {
      const res = await apiClient.users.organizations();
      return res.result;
    },

    // 5 minutes
    staleTime: 5000 * 60
  });
};
